import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpErrorHandlerService } from '../http-error-handler.service';

export interface UploadOrderPdfResponse {
  isSuccess: boolean;
}

export interface DeleteOrderPdfResponse {
  isSuccess: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class OrderPdfService {
  private readonly baseUrl = `${environment.url}/order-pdf`;
  static readonly PDF_KIND_DELIVERY_NOTE = 1;

  constructor(
    private http: HttpClient,
    private httpErrorHandler: HttpErrorHandlerService
  ) {}
  uploadDeliveryNote(
    orderHash: string,
    pdfId: string
  ): Observable<UploadOrderPdfResponse> {
    return this.http
      .post<UploadOrderPdfResponse>(`${this.baseUrl}/upload`, {
        orderHash,
        pdfId
      })
      .pipe(catchError((error) => this.httpErrorHandler.handleError(error)));
  }
  deleteDeliveryNote(
    orderHash: string,
    pdfId: string
  ): Observable<DeleteOrderPdfResponse> {
    return this.http
      .request<DeleteOrderPdfResponse>('DELETE', `${this.baseUrl}/delete`, {
        body: { orderHash, pdfId }
      })
      .pipe(catchError((error) => this.httpErrorHandler.handleError(error)));
  }
}
